import { Box, Grid, IconButton, Typography } from "@mui/material";

import BannerWrapper from "../BannerWrapper";

interface Props {
  pastDuePlan: string;
}

const PastDueBanner = ({ pastDuePlan }: Props) => {
  return (
    <BannerWrapper color={"#C92D0A"} fromPastDue={true}>
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          <Box component="i" className="fa-regular fa-warning" sx={{ mr: 1 }} />
          Action required: we could not process your latest payment for{" "}
          <strong>{pastDuePlan}</strong> plan. Please update to restore access.
        </Typography>

        <IconButton sx={{ fontSize: 14 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white" }}
          />
        </IconButton>
      </Grid>
    </BannerWrapper>
  );
};

export default PastDueBanner;
